
<div class="main-debug">
  <!-- <vue-draggable-resizable
    axis="y"
    :z="10000"
    style="position:absolute; bottom:220px;right:48px; height:0px;width:0px"
  >
    <div id="debug-button" :style="envStyle" v-show="showMagic">
      <i class="fa fa-smile-beam fa-3x shadow" @click="goToControlCentre" />
    </div>
  </vue-draggable-resizable>-->

  <div class="modal coming-soon-modal">
    <div class="modal-background" @click="closeModal"></div>
    <button
      class="modal-close is-large"
      aria-label="close"
      @click="closeModal"
    ></button>
    <div class="modal-card">
      <section class="modal-card-body has-text-left">
        <span
          class="is-size-5 has-text-info has-text-weight-semibold"
          @click="closeModal"
        >
          {{ title }}
        </span>
        <span class="is-pulled-right link" @click="toggleCookies">
          {{ buttonName }}
        </span>
        <div class="pre" @click="toggleCookies">
          <div class="code">
            <ul v-if="!isCookies">
              <li v-for="(event, index) in debug" v-bind:key="index">
                {{ event }}
              </li>
            </ul>
            <ul v-if="isCookies">
              <li v-for="(cookie, index) in cookies" v-bind:key="index">
                {{ cookie }}
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
